import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { isEqual } from 'Utils/lodashUtils';
import './drawer.scss';

export class Drawer extends React.Component {
  constructor(props) {
    super(props);
    this.attachBindings();
    const sessionState = JSON.parse(sessionStorage.getItem("state"));
    this.state = {
      isToggledExitModal: false,
      showLoader: props.profile && Object.keys(props.profile).length > 0 ? false : true,
      accessToken: sessionStorage.getItem("__gp_auth_token__"),
      userSource: sessionState && sessionState.auth ? sessionState.auth.user.source : null,
      acquirer: sessionState && sessionState.auth ? sessionState.auth.user.acquirerCode : null,
    };
  }

  componentDidUpdate(prevProps) {
    if(this.props.profile && 
      Object.keys(this.props.profile).length !== 0 && 
      !isEqual(this.props.profile, prevProps.profile)
    ) {
      this.setState({
        showLoader: false
      });
    }
  }

  attachBindings() {
    this.toggleExitModal = this.toggleExitModal.bind(this);
    this.confirmEndAccess = this.confirmEndAccess.bind(this);
    this.getSessionToken = this.getSessionToken.bind(this);
  }

  toggleExitModal() {
    this.props.toggleOverlay();
    this.setState({
      isToggledExitModal: !this.state.isToggledExitModal,
    });
  }

  confirmEndAccess() {
    this.props.toggleOverlay();
    this.toggleExitModal();
  }

  getSessionToken () {
    return this.state.accessToken;
  }


  render() {
    const drawerClasses = classNames('drawer', {
      open: this.props.isDrawerOpen || this.props.isSecondaryDrawerOpen,
      extended: this.props.drawerIsExtended,
      'secondary-open': this.props.isSecondaryDrawerOpen && this.props.drawerIsExtended,
    });

    return (
    <section className={drawerClasses}>
    </section> 
    );
  }
}

const mapStateToProps = (state) => ({
  reportSupport: {}
});


Drawer.propTypes = {
  drawerIsExtended: PropTypes.bool,
  isDrawerOpen: PropTypes.bool,
  isSecondaryDrawerOpen: PropTypes.bool,
  toggleDrawer: PropTypes.func,
  toggleSecondaryDrawer: PropTypes.func,
  useExtendedDrawer: PropTypes.func,
  level: PropTypes.string,
  filteredRows: PropTypes.array,
  toggleOverlay: PropTypes.func,
  toggleSupportRequest: PropTypes.func,
};

Drawer.defaultProps = {
  toggleDrawer: () => { },
  isSecondaryDrawerOpen: false,
  drawerIsExtended: false,
  toggleSecondaryDrawer: () => { },
  isDrawerOpen: false,
  isSupportProvider: false,
  useExtendedDrawer: () => { },
  level: '',
  filteredRows: [],
  toggleOverlay: () => { },

};

export default withRouter(connect(mapStateToProps, null)(Drawer));
